import { render, staticRenderFns } from "./ProjectNotes.vue?vue&type=template&id=83a74a3a&scoped=true"
import script from "./ProjectNotes.vue?vue&type=script&lang=js"
export * from "./ProjectNotes.vue?vue&type=script&lang=js"
import style0 from "./ProjectNotes.vue?vue&type=style&index=0&id=83a74a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a74a3a",
  null
  
)

export default component.exports